if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._ffOriginalParent = null;
        this._ffOriginalNextSibling = null;
      }

      hide() {
        document.body.classList.remove('ff-product-zoom-open');

        // Restore modal to its original place in the product section
        if (this._ffOriginalParent) {
          if (this._ffOriginalNextSibling && this._ffOriginalNextSibling.parentNode === this._ffOriginalParent) {
            this._ffOriginalParent.insertBefore(this, this._ffOriginalNextSibling);
          } else {
            this._ffOriginalParent.appendChild(this);
          }
          this._ffOriginalParent = null;
          this._ffOriginalNextSibling = null;
        }

        super.hide();
      }

      show(opener) {
        // Move to <body> so overflow/stacking on .ff-product-section
        // cannot trap the lightbox under the sticky header.
        if (!this._ffOriginalParent) {
          this._ffOriginalParent = this.parentElement;
          this._ffOriginalNextSibling = this.nextSibling;
        }
        document.body.appendChild(this);
        document.body.classList.add('ff-product-zoom-open');

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
